import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './SuccessPage.css';
import api from '../../services/publicApi';
import { useCart } from '../../cart/CartContext';

const SuccessPage = () => {
    const cart = useCart();
    const settleRef = React.useRef(cart?.settle);
    settleRef.current = cart?.settle;
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('order_id');
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading');
    const [refreshCount, setRefreshCount] = useState(0);

    useEffect(() => {
        let cancelled = false;
        let timer;
        setStatus('loading');
        const poll = async (attempt = 0) => {
            if (!orderId || !token) {
                if (!cancelled) setStatus('error');
                return;
            }
            try {
                const data = await api.purchases.getPublic(orderId, token);
                if (cancelled) return;
                if (data.status_code === 'payment_conflict' || data.status_code === 'returned') {
                    setStatus('review');
                } else if (data.payment_status === 'succeeded' || ['paid', 'in_delivery', 'delivered'].includes(data.status_code)) {
                    settleRef.current?.(orderId, true);
                    setStatus('paid');
                } else if (['cancelled', 'expired'].includes(data.status_code) || data.payment_status === 'canceled') {
                    settleRef.current?.(orderId, false);
                    setStatus('cancelled');
                } else if (attempt < 14) {
                    setStatus('loading');
                    timer = window.setTimeout(() => poll(attempt + 1), 2000);
                } else {
                    setStatus('pending');
                }
            } catch (error) {
                if (cancelled) return;
                if (attempt < 14 && ![403, 404].includes(error.status)) {
                    timer = window.setTimeout(() => poll(attempt + 1), 2000);
                } else {
                    setStatus('error');
                }
            }
        };
        poll();
        return () => {
            cancelled = true;
            if (timer) window.clearTimeout(timer);
        };
    }, [orderId, token, refreshCount]);

    if (status === 'loading') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <p>Проверка платежа...</p>
                </div>
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <div className="success-icon">❌</div>
                    <h1>Ошибка</h1>
                    <p className="success-text">Не удалось проверить статус заказа.</p>
                    {orderId && token && <button type="button" className="btn btn-primary success-btn" onClick={() => setRefreshCount(value => value + 1)}>Проверить ещё раз</button>}
                    <a href="/" className="btn btn-primary success-btn">На главную</a>
                </div>
            </div>
        );
    }

    if (status === 'pending') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <div className="success-icon">⏳</div>
                    <h1>Проверяем подтверждение оплаты</h1>
                    <p className="success-text">Подтверждение от ЮKassa пока не получено. Если деньги уже списаны, дождитесь обновления статуса.</p>
                    <button type="button" className="btn btn-primary success-btn" onClick={() => setRefreshCount(value => value + 1)}>Проверить ещё раз</button>
                    <a href="/" className="btn btn-primary success-btn">На главную</a>
                </div>
            </div>
        );
    }

    if (status === 'cancelled' || status === 'review') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <h1>{status === 'cancelled' ? 'Заказ отменён или срок оплаты истёк' : 'Статус заказа требует проверки'}</h1>
                    {orderId && <p className="success-order">Заказ <strong>№{orderId}</strong></p>}
                    <p className="success-text">{status === 'cancelled' ? 'Вернитесь в каталог, чтобы оформить заказ заново. Если деньги уже списаны, свяжитесь с магазином и укажите номер заказа.' : 'Свяжитесь с магазином и укажите номер заказа. Не оплачивайте этот заказ повторно.'}</p>
                    <a href="/#contacts" className="btn btn-primary success-btn">Связаться с магазином</a>
                    <a href="/" className="btn btn-primary success-btn">На главную</a>
                </div>
            </div>
        );
    }

    return (
        <div className="success-page">
            <div className="success-container">
                <div className="success-icon">✅</div>
                <h1>Оплата прошла успешно!</h1>
                {orderId && <p className="success-order">Заказ <strong>№{orderId}</strong></p>}
                <p className="success-text">Менеджер свяжется с вами и передаст трек-номер.</p>
                <a href="/" className="btn btn-primary success-btn">На главную</a>
            </div>
        </div>
    );
};

export default SuccessPage;
